import { render, staticRenderFns } from "./SocialStatuseDelete.vue?vue&type=template&id=241becfe&"
import script from "./SocialStatuseDelete.vue?vue&type=script&lang=js&"
export * from "./SocialStatuseDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports